var DevOps = "DevOps";
var Gaming = "Computerspiele";
var Migration = "Migration";
var Other = "Sonstiges";
var useCase = {
	"Use case": "Anwendungsfall",
	"AI & machine learning": "KI und Machine Learning",
	"Batch processing": "Stapelverarbeitung",
	"Big data, analytics, & business intelligence": "Big Data, Analysen und Business Intelligence",
	"Business applications - Microsoft": "Geschäftsanwendungen – Microsoft",
	"Business applications - Oracle": "Geschäftsanwendungen – Oracle",
	"Business applications - Other": "Geschäftsanwendungen – Sonstige",
	"Business applications - SAP": "Geschäftsanwendungen – SAP",
	"Content delivery": "Inhaltsbereitstellung",
	DevOps: DevOps,
	Gaming: Gaming,
	"Internet of things": "Internet of Things",
	"Learning & certification": "Schulung und Zertifizierung",
	"Media services": "Medienservices",
	Migration: Migration,
	"Mobile applications": "Mobile Anwendungen",
	Other: Other,
	"Storage & backup": "Speichern und Sichern",
	"Websites & web apps": "Websites und Web-Apps"
};

export { DevOps, Gaming, Migration, Other, useCase as default };
